import { useQuery } from '@tanstack/react-query';
import { bookingsApi } from './bookings.api';

export function useDueSoon(minutes: number = 30) {
  return useQuery({
    queryKey: ['bookings.due-soon', minutes],
    queryFn: async () => {
      const resp = await bookingsApi.dueSoon(minutes);
      return resp || [];
    },
    refetchInterval: 30000, // 30 seconds
  });
}
